import { render, staticRenderFns } from "./PostAuthorInfoMod.vue?vue&type=template&id=2cfd45c3&scoped=true"
import script from "./PostAuthorInfoMod.vue?vue&type=script&lang=js"
export * from "./PostAuthorInfoMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfd45c3",
  null
  
)

export default component.exports